import { observer } from "mobx-react";
import { chatStore } from "store/chatStore";
import ChatEmptyState from "./ChatEmptyState";
import MessageList from "./MessageList";

const ChatWindow = observer(function ChatWindow() {
  if (chatStore.isEmptyChat && !chatStore.isAiResponding) {
    return <ChatEmptyState />;
  }

  return <MessageList />;
});

export default ChatWindow;
